import React from 'react';
import {Avatar, type AvatarProps} from '@mui/material';
import {strToHslColor, styled} from '@netx/core-components/Theme';

const ColoredAvatarRoot = styled(Avatar)({
	paddingTop: 2,
});

export interface ColoredAvatarProps extends Omit<
	AvatarProps,
	'alt' | 'children' | 'imgProps' | 'sizes' | 'src' | 'srcSet'
> {
	label: string;
	loading?: boolean;
	monoChrome?: boolean;
}

export const ColoredAvatar = ({
	label,
	loading,
	monoChrome,
	...props
}: ColoredAvatarProps) => {
	return (
		<ColoredAvatarRoot
			aria-hidden="true"
			{...props}
			style={{
				backgroundColor:
					!label || loading
						? '#cccccc'
						: monoChrome
							? undefined
							: strToHslColor(label, 25, 55),
				...props.style,
			}}
		>
			{loading || !label ? '' : label.charAt(0).toLocaleUpperCase()}
		</ColoredAvatarRoot>
	);
};

export default ColoredAvatar;
